module.exports = __webpack_public_path__ + "static/media/takeControlImg.8703fdc2.png";